module.exports = __webpack_public_path__ + "img/magafaim_yes.f4c8429c.png";